import React from 'react';
import FlyoutSwitch, {FORECASTING_FLYOUT_MODE} from '../common/FlyoutSwitch';

const FlyoutReplines = () => {
	return <FlyoutSwitch startMode={FORECASTING_FLYOUT_MODE.REPLINES_LIST} />;
};

export default FlyoutReplines;
